<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">Bienvenido</h4>
                    <div class="menu-cards-container">
                        <div class="row m-0">
                            <div class="col-lg-6 col-md-6 col-sm-12 p-2">
                                <div class="menu-card">
                                    <div class="menu-card-icon">
                                        <img src="assets/images/elroblelogo2.jpg" alt="Pago de Prima" />
                                    </div>
                                    <div class="menu-card-content">
                                        <h5 class="menu-card-title">Pago de Prima</h5>
                                        <p class="menu-card-subtitle">Gestor de pagos de prima</p>
                                    </div>
                                    <button @click="$router.push('/busqueda/dpi/0')" class="btn__acceder menu-card-button">
                                        Acceder
                                        <i class="arrow-icon">→</i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 p-2">
                                <div class="menu-card">
                                    <div class="menu-card-icon">
                                        <img src="assets/images/elroblelogo2.jpg" alt="Pago de Deducible" />
                                    </div>
                                    <div class="menu-card-content">
                                        <h5 class="menu-card-title">Pago de Deducible</h5>
                                        <p class="menu-card-subtitle">Gestor de pagos de deducible</p>
                                    </div>
                                    <button @click="$router.push('/reclamos/placa/0')" class="btn__acceder menu-card-button">
                                        Acceder
                                        <i class="arrow-icon">→</i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 p-2">
                                <div class="menu-card">
                                    <div class="menu-card-icon">
                                        <img src="assets/images/elroblelogo2.jpg" alt="Pago de Re-cobro" />
                                    </div>
                                    <div class="menu-card-content">
                                        <h5 class="menu-card-title">Pago de Re-cobro</h5>
                                        <p class="menu-card-subtitle">Gestor de pagos de re-cobro</p>
                                    </div>
                                    <button @click="$router.push('/recobro-menu')" class="btn__acceder menu-card-button">
                                        Acceder
                                        <i class="arrow-icon">→</i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 p-2">
                                <div class="menu-card">
                                    <div class="menu-card-icon">
                                        <img src="assets/images/elroblelogo2.jpg" alt="Actualización de datos" />
                                    </div>
                                    <div class="menu-card-content">
                                        <h5 class="menu-card-title">Actualización de datos</h5>
                                        <p class="menu-card-subtitle">Actualizar información del cliente</p>
                                    </div>
                                    <button @click="$router.push('/actualizacion-datos')" class="btn__acceder menu-card-button">
                                        Acceder
                                        <i class="arrow-icon">→</i>
                                    </button>
                                </div>
                            </div>
                            <!--<div class="col-lg-6 col-md-6 col-sm-12 p-2" v-if="typeof userAccess['rutacobros/crear/editar'] !== 'undefined'">-->
                            <div class="col-lg-6 col-md-6 col-sm-12 p-2">
                                <div class="menu-card">
                                    <div class="menu-card-icon">
                                        <img src="assets/images/elroblelogo2.jpg" alt="Ruta de cobros" />
                                    </div>
                                    <div class="menu-card-content">
                                        <h5 class="menu-card-title">Ruta de cobros</h5>
                                        <p class="menu-card-subtitle">Gestión de rutas de cobro</p>
                                    </div>
                                    <button @click="$router.push('/ruta-cobros')" class="btn__acceder menu-card-button">
                                        Acceder
                                        <i class="arrow-icon">→</i>
                                    </button>
                                </div>
                            </div>
<!--                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> Siniestros
                                </div>
                            </div>
                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> recobro
                                </div>
                            </div>
                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> Salvamentos
                                </div>
                            </div>-->
                            <!--<div class="col-6 p-1">
                                <div @click="visanet" class="item-menu">
                                    Pago Visanet
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/Layout";
import AndroidBridge from "src/core/AndroidBridge";
import Tools from "src/core/Tools";
import {mapGetters} from "vuex";


export default {
    props: {
    },
    data() {
        return {
            userAccess: {},
            isOnApp: false,
            androidBridge: false,
        };
    },
    components: {
        //TimelineChart,
        Layout,
        //Toster,

        showConfig: false,
    },
    mounted() {
        this.androidBridge = new AndroidBridge();
        this.androidBridge.enablePressBackToOut('http://localhost/');
        this.userAccess = this.AuthUserAccess();
    },
    methods: {
        ...mapGetters(["AuthUserAccess"]),
    }
};
</script>
